import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { createEmployeeAuth } from "../../../actions/employeeAuthAction";
import { getAllEmployee } from "../../../actions/employeeAction";
import {
    Form,
    Input,
    Drawer,
    Button,
    Col,
    Row,
    Select,
    Checkbox,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

const CreateEmployeeAuth = ({
    createEmployeeAuth,
    getAllEmployee,
    employees,
    setUpdatelist,
    updatelist,
}) => {
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();

    const showDrawer = () => {
        getAllEmployee();
        setVisible(true);
    };

    const onClose = () => {
        form.resetFields();
        setVisible(false);
    };

    const onFinish = (values) => {
        createEmployeeAuth(values);
        form.resetFields();
        setUpdatelist(!updatelist);
        setVisible(false);
    };

    return (
        <>
            <Button
                type="primary"
                onClick={showDrawer}
                style={{ marginBottom: "10px", float: "right" }}
            >
                <PlusOutlined /> New PIN Setup
            </Button>
            <Drawer
                title="Create Employee PIN"
                width={400}
                onClose={onClose}
                visible={visible}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    initialValues={{ is_admin: false, is_staff: true }}
                >
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="employee"
                                label="Employee"
                                rules={[{ required: true, message: "Please select an employee" }]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Select an employee"
                                    optionFilterProp="children"
                                    style={{ color: "black" }}
                                    onChange={(value) => {
                                        const emp = employees.find(e => e.id === value);
                                        if (emp) {
                                            form.setFieldsValue({ employee_name: emp.name });
                                        }
                                    }}
                                >
                                    {employees.map((emp) => (
                                        <Option key={emp.id} value={emp.id}>
                                            {emp.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="employee_name"
                                label="Display Name (Employee Name)"
                                rules={[{ required: true, message: "Please enter employee name" }]}
                            >
                                <Input placeholder="Employee Name" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                name="pin"
                                label="6-Digit PIN"
                                rules={[
                                    { required: true, message: "Please enter a PIN" },
                                    { len: 6, message: "PIN must be exactly 6 digits" }
                                ]}
                            >
                                <Input.Password maxLength={6} placeholder="Enter 6-digit PIN" />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item name="remarks" label="Remarks">
                                <Input.TextArea rows={2} placeholder="Optional remarks" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="is_admin" valuePropName="checked">
                                <Checkbox>Is Admin</Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="is_staff" valuePropName="checked">
                                <Checkbox>Is Staff</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item>
                        <Button onClick={onClose} style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Drawer>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        employees: state.employee.employeelist || [],
    };
};

export default connect(mapStateToProps, {
    createEmployeeAuth,
    getAllEmployee,
})(CreateEmployeeAuth);
